var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ty-modal',{attrs:{"visible":true,"before-close":_vm.handleClose,"width":"60%"}},[_c('Create',{staticClass:"mt-3",on:{"created":_vm.created}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }